import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  observeLine: null,
  alertLine: null,
  dangerLine: null,
};

const thresholdLinesSlice = createSlice({
  name: 'thresholdLines',
  initialState,
  reducers: {
    setThresholdLines: (state, action) => {
      state.observeLine = action.payload.observeLine;
      state.alertLine = action.payload.alertLine;
      state.dangerLine = action.payload.dangerLine;
    },
  },
});

export const { setThresholdLines } = thresholdLinesSlice.actions;
export default thresholdLinesSlice.reducer;